import styled from 'styled-components/macro';

export const IFrameWrapper = styled.div`
  > iframe {
    width: 100%;
    height: 250px;
    margin-top: 1rem;
    border-radius: 4px;
  }
`;

export const ClearMapWrapper = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
`;

export const GoogleAutocompleteWrapper = styled.div`
  width: 100%;
`;

export const FormikGoogleMapsWrapper = styled.div`
  width: 100%;
`;
